import { fromJS } from 'immutable';

import { UPDATE_USER, CLEAR_USER } from './constants';

const initialState = fromJS({
  currentUser: null,
  userData: fromJS({
    id: null,
    organisationId: null,
    auth0_id: null,
    email: null,
    name: null,
    nickname: null,
    picture: null,
    roles: [],
  }),
  userLoaded: false,
});

function userReducer(state = initialState, action) {
  switch (action.type) {
  case UPDATE_USER:
    return state
      .set('currentUser', action.user.name)
      .setIn(['userData', 'id'], action.user.id)
      .setIn(['userData', 'organisationId'], action.user.organisationId)
      .setIn(['userData', 'auth0_id'], action.user.auth0_id)
      .setIn(['userData', 'email'], action.user.email)
      .setIn(['userData', 'name'], action.user.name)
      .setIn(['userData', 'nickname'], action.user.nickname)
      .setIn(['userData', 'picture'], action.user.picture)
      .setIn(['userData', 'roles'], action.user.roles)
      .set('userLoaded', true);
  case CLEAR_USER:
    return initialState;
  default:
    return state;
  }
}

export default userReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/user-widget/reducer.js
 **/